<template>
  <div class="WSelect" tabindex="-1" @blur="show = false">
    <div
      class="select_com"
      @click="show = !show"
      :class="{ active_select_box: show }"
    >
      <span v-if="selectItem[value]">{{ selectItem[label] }}</span>
      <template v-else>
        <slot></slot>
      </template>
      <img
        class="select_icon_com"
        src="@/assets/img/PC/recharge/selectdown.png"
        :class="{ rotate: show }"
      />
    </div>
    <div class="select_item_list" :class="{ active_select_item_list: show }">
      <div
        v-for="(item, index) in options"
        :key="index"
        class="select_item_menu"
        :class="{ active_select_item_menu: selectItem[value] == item[value] }"
        @click="selectClick(item)"
      >
        {{ item[label] }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  //定义实现v-modal的属性与事件
  model: {
    prop: "valueData",
    event: "change",
  },
  props: {
    label: {
      type: String,
      default: "label",
    },
    value: {
      type: String,
      default: "value",
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    options: {
      type: Array,
      default: () => [],
    },
    //绑定的值
    valueData: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    selectItem() {
      return this.options.find((el) => el[this.value] == this.valueData) || [];
    },
  },
  methods: {
    selectClick(item) {
      // this.selectItem = item;
      console.log("执行");
      this.show = false;
      this.$emit("change", item[this.value]);
    },
  },
};
</script>

<style scoped>
.WSelect {
  height: 50px;
  position: relative;
}

.select_com {
  height: 50px;
  line-height: 50px;
  border-radius: 8px;
  opacity: 1;
  border: 1px solid #e4e8ef;
  background: #fff;
  overflow: hidden;
  position: relative;
  padding: 0px 45px 0px 20px;
  cursor: pointer;
  transition: all 0.2s;
}

.active_select_box {
  border-color: #6e3eff;
}

.placeholder {
  color: #999999;
  font-size: 14px;
  font-weight: 400;
}

.select_icon_com {
  width: 24px;
  height: 24px;
  position: absolute;
  right: 17px;
  top: 13px;
  transition: all 0.2s;
}

.rotate {
  transform: rotateZ(180deg);
}

.select_item_list {
  margin-top: 2px;
  border-radius: 8px;
  opacity: 1;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.25);
  height: 0;
  max-height: 370px;
  overflow: auto;
  z-index: 999;
  position: absolute;
  width: 100%;
  box-sizing: border-box;
}

.active_select_item_list {
  height: auto;
}

.select_item_menu {
  box-sizing: border-box;
  padding: 9px 16px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
}

.active_select_item_menu {
  color: #6e3eff;
}

.select_item_menu:hover {
  background-color: #eee;
}
</style>
